import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'item',
		'itemCounter',
	]

	connect() {
	}

	itemTargetConnected() {
		this.debounce(() => {
			this.updateItemCounter()
		}, 10)()
	}

	itemTargetDisconnected() {
		this.debounce(() => {
			this.updateItemCounter()
		}, 10)()
	}

	getItemCount() {
		return this.itemTargets.length
	}

	updateItemCounter() {
		if (this.hasItemCounterTarget) {
			if (this.hasItemTarget) {
				const presentItemCount = this.itemTargets.filter(item => !this.isItemPresent(item)).length
				this.itemCounterTarget.innerText = presentItemCount
			} else {
				this.itemCounterTarget.innerText = "0"
			}
		}
	}

	isItemPresent(item) {
		!item.classList.contains('d-none')
		&& !item.classList.contains('empty-placeholder') 
		&& !item.classList.contains('mark-to-destroy')
	}

	debounce(func, wait) {
		let timeout
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout)
				func(...args)
			}
			clearTimeout(timeout)
			timeout = setTimeout(later, wait);
		}
	}
}

